import React from 'react'
import {Drawer} from '@mui/material'
import {SIDEBAR_WIDTH_EXPANDED} from 'src/theme-new/tokens'
import SideNav from './SideNav'
import {NavItemConfig} from './types'

interface MobileDrawerProps {
  open: boolean
  onClose: () => void
  navItems: NavItemConfig[]
}

const MobileDrawer = ({open, onClose, navItems}: MobileDrawerProps): JSX.Element => {
  return (
    <Drawer
      variant="temporary"
      anchor="left"
      open={open}
      onClose={onClose}
      ModalProps={{keepMounted: true}}
      sx={{
        '& .MuiDrawer-paper': {
          width: SIDEBAR_WIDTH_EXPANDED,
          boxSizing: 'border-box',
          overflowX: 'hidden',
        },
      }}
    >
      <SideNav expanded={true} onToggle={onClose} onNavClick={onClose} navItems={navItems} />
    </Drawer>
  )
}

export default MobileDrawer
